import { getProjectData } from "@appmaker/core/store/project"

const RedirectV3 = ({ id = 'extension' }) => {

    const data = getProjectData();
    const { projectData = {}, projectId } = data;
    const { migration = {} } = projectData
    const { isExtensionInstallMigrated = false, isThemeInstallMigrated = false } = migration;

    const redirect = (url) => {
        // App Bridge v4: Use window.open instead of Redirect action
        window.open(url, '_top');
    }

    if (id === 'extension' && !isExtensionInstallMigrated) {
        redirect('https://v3.appmaker.xyz/apps/' + projectId + '/extensions')
    }
    if (id === 'theme' && !isThemeInstallMigrated) {
        redirect('https://v3.appmaker.xyz/apps/' + projectId + '/themes')
    }
    return null;
}

export default RedirectV3